export var TARGET_SCROLL_MODE = 'target';
export var SCROLL_POSITION_SCROLL_MODE = 'scrollPosition';